export const absenceList = [
    {
      value: 6,
      label: 'Active',
    },
    {
      value: 1,
      label: 'Day Off',
    },
    {
      value: 2,
      label: 'Vacations',
    },
    {
      value: 3,
      label: 'Maternity leave',
    },
    {
      value: 4,
      label: 'Sick',
    },
  ]

export const DEFAULT_SHIFT_COLORS = {
  color: '#ff9900',
  iconColor: '#F4F5F7',
  textColor: '#F4F5F7',
}

export const toShiftHexColor = (color?: string): string => {
  if (!color?.trim()) return '000000'

  const value = color.trim()

  if (/^[0-9a-fA-F]{6}$/.test(value)) return value.toLowerCase()
  if (/^#[0-9a-fA-F]{6}$/.test(value)) return value.slice(1).toLowerCase()
  if (/^#[0-9a-fA-F]{3}$/.test(value)) {
    const short = value.slice(1)
    return short
      .split('')
      .map((char) => char + char)
      .join('')
      .toLowerCase()
  }

  const rgbMatch = value.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i)
  if (rgbMatch) {
    return [rgbMatch[1], rgbMatch[2], rgbMatch[3]]
      .map((part) => Math.min(255, Math.max(0, Number(part))).toString(16).padStart(2, '0'))
      .join('')
      .toLowerCase()
  }

  if (typeof document !== 'undefined') {
    const canvas = document.createElement('canvas')
    canvas.width = 1
    canvas.height = 1
    const ctx = canvas.getContext('2d')
    if (ctx) {
      ctx.fillStyle = '#000000'
      ctx.fillStyle = value
      const parsed = ctx.fillStyle
      if (typeof parsed === 'string' && /^#[0-9a-fA-F]{6}$/.test(parsed)) {
        return parsed.slice(1).toLowerCase()
      }
    }
  }

  return '000000'
}

export const getShiftValidationError = (state: any): string | null => {
  if (!state?.name?.trim()) {
    return 'Shift name must be entered'
  }
  if (!state?.absenceType?.value) {
    return 'Shift type must be selected'
  }
  if (state.absenceType.value == 6) {
    if (!state?.range?.startSelected) {
      return 'From time must be selected'
    }
    if (!state?.range?.minutesSelected) {
      return 'To time must be selected'
    }
  }
  if (!state?.icon) {
    return 'Icon must be selected'
  }
  return null
}
